import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
  ifDefined,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  handleAdobeNavEvent,
  adobeCleanString,
} from '../../../helpers/adobe-analytics';

export class Grace extends Lit3formBlock {
  static get characterName() {
    return 'grace';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div
          class="${classMap({
            'block-grid': true,
            'grace-layout': true,
            'mobile-rows-1': this.oneRowNeeded,
            'mobile-rows-2': this.twoRowsNeeded,
          })}"
        >
          ${this.blockHeaderHTML} ${this.imagesArrHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get imagesArrHTML() {
    if (this.imagesArr.length) {
      return html`
        <div class="images-wrapper">
          ${this.imagesArr.map(i => {
            const image = i[1];
            return html`
              <a
                class="image-wrapper"
                href=${ifDefined(image.cta && image.cta.url)}
                @click=${() => this.imageClicked(image)}
              >
                <div class="img-container">
                  <img src=${this.imageSrc(image)} />
                </div>
                <div class="details">
                  <h2>
                    ${unsafeHTML(this.withLineBreaks(this.imageHeader(image)))}
                  </h2>
                  ${image.cta && image.cta.text
                    ? html`
                        <div class="image-cta">
                          <cta-text
                            cta-data=${this.ctaData(image.cta)}
                          ></cta-text>
                        </div>
                      `
                    : html`
                        <p class="description">
                          ${unsafeHTML(this.withLineBreaks(image.description))}
                        </p>
                      `}
                </div>
              </a>
            `;
          })}
        </div>
      `;
    } else {
      return html``;
    }
  }

  get blockHeaderHTML() {
    return !!this.content.header
      ? html`
          <h3 class="block-header">${this.headerText}</h3>
        `
      : html``;
  }

  get headerText() {
    return this.withLineBreaks(this.content.header) || '';
  }

  imageClicked(image) {
    const dataObject = analyticsCtaDataObject(image, this.placementText(image));
    handleAdobeNavEvent(dataObject);
  }

  placementText(img) {
    const text = this.imageHeader(img) || this.headerText || 'Grace Image';
    return text;
  }

  imageSrc(image) {
    return this.imagebossUrl(image.src, null, 400);
  }

  ctaData(cta) {
    return JSON.stringify({
      notBold: true,
      url: cta.url,
      text: cta.text,
    });
  }

  imageHeader(image) {
    return image.header || '';
  }

  get imagesArr() {
    if (!this.content.images || this.content.images.length === 0) {
      return [];
    }
    return this.content.images;
  }

  get oneRowNeeded() {
    return this.mobileRowsNeeded === 1;
  }

  get twoRowsNeeded() {
    return this.mobileRowsNeeded === 2;
  }

  get mobileRowsNeeded() {
    let count = 0;
    if (!!this.content.header) count++;
    if (!!this.imagesArr.length) count++;
    return count;
  }
}
Grace.defineElement();
